import {
  CONSOLE_RUN_CODE,
  CONSOLE_RUN_CODE_SUCCESS,
  CONSOLE_RUN_CODE_FAILURE,
  CONSOLE_SET_INPUT,
  CONSOLE_CLEAR_ALL,
} from '../types/consoleTypes';

const initialState = {
  input: '',
  output: '',
  queryStartTime: null,
  queryEndTime: null,
  loading: false,
  error: null,
};

const consoleReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSOLE_SET_INPUT:
      return { ...state, input: action.payload };
    case CONSOLE_RUN_CODE:
      return {
        ...state,
        queryStartTime: Date.now(),
        queryEndTime: null,
        loading: true,
      };
    case CONSOLE_RUN_CODE_SUCCESS:
      return {
        ...state,
        queryEndTime: Date.now(),
        loading: false,
        error: null,
        output: action.payload.result,
      };
    case CONSOLE_RUN_CODE_FAILURE:
      return {
        ...state,
        queryEndTime: Date.now(),
        loading: false,
        error: action.payload,
      };
    case CONSOLE_CLEAR_ALL:
      return {
        ...state,
        queryStartTime: null,
        queryEndTime: null,
        input: '',
        output: '',
      };
    default:
      return state;
  }
};

export default consoleReducer;
